import * as React from 'react'

const InstantArticleScriptNotes = () => (
	<ul>
		<li>
			We recommend to load the script as soon as possible on any page of your website. This ensures there is
			minimal delay when showing the instant article.
		</li>
		<li>
			The script does not require user consent, since we do not set cookies or gather any personal information
			with it.
		</li>
		<li>
			The same script works for all future campaigns. You need to implement it only the first time you do an
			instant article campaign.
		</li>
	</ul>
)

export default InstantArticleScriptNotes
